<script lang="ts">
  import SimpleSensitiveText from '$shared/atoms/SimpleSensitiveText/SimpleSensitiveText.svelte';
  import { EmptyLabelDefault } from '$provider/constants/global';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';

  interface Props {
    alert: DataListAlert;
  }

  let { alert }: Props = $props();
</script>

{#if alert.isSensitiveValue}
  <SimpleSensitiveText value={alert.value} />
{:else if alert.componentInfo?.component}
  <alert.componentInfo.component {...alert.componentInfo?.props || {}} />
{:else}
  {alert.value || EmptyLabelDefault}
{/if}
